'use es6';

import createAction from 'flux-actions/createAction';
import { ARCHIVED_AND_UNPUBLISHED_CONTENT, ARCHIVED_CONTENT, ATTACHED_TO_LANGUAGE_MASTER, CHANGED_CONTENT_AUDIENCE_ACCESS, CLONED_CONTENT, CLOSE_MODAL, CONVERTED_CONTENT, CREATED_TRANSLATION_VARIATION, DELETED_CONTENT, OPEN_MODAL, PUBLISHED_CONTENT, UNARCHIVED_CONTENT, UNPUBLISHED_CONTENT, UPDATE_SOCIAL_COMPOSER_PARAMS, OPEN_SOCIAL_COMPOSER, CLOSE_SOCIAL_COMPOSER, OPEN_ADS_PANEL, CLOSE_ADS_PANEL, REMOVE_FROM_LANGUAGE_GROUP } from './ActionTypes';
export const openModal = createAction(OPEN_MODAL, ({
  modalName,
  modalOverrides
}) => ({
  modalName,
  modalOverrides
}));
export const closeModal = createAction(CLOSE_MODAL);
export const openSocialComposer = createAction(OPEN_SOCIAL_COMPOSER, params => params);
export const updateSocialComposerParams = createAction(UPDATE_SOCIAL_COMPOSER_PARAMS, params => params);
export const closeSocialComposer = createAction(CLOSE_SOCIAL_COMPOSER);
export const openAdsPanel = createAction(OPEN_ADS_PANEL);
export const closeAdsPanel = createAction(CLOSE_ADS_PANEL, params => params);
export const archiveContent = createAction(ARCHIVED_CONTENT, ({
  contentType,
  id
}) => ({
  contentType,
  id
}));
export const archiveAndUnpublishContent = createAction(ARCHIVED_AND_UNPUBLISHED_CONTENT, ({
  contentPageId,
  contentType
}) => ({
  contentPageId,
  contentType
}));
export const unarchiveContent = createAction(UNARCHIVED_CONTENT, ({
  contentType,
  id
}) => ({
  contentType,
  id
}));
export const unpublishContent = createAction(UNPUBLISHED_CONTENT, ({
  contentPageId,
  contentType
}) => ({
  contentPageId,
  contentType
}));
export const publishContent = createAction(PUBLISHED_CONTENT, ({
  contentPageId,
  contentType
}) => ({
  contentPageId,
  contentType
}));
export const cloneContent = createAction(CLONED_CONTENT, ({
  categoryId,
  contentType,
  id,
  name
}) => ({
  categoryId,
  contentType,
  id,
  name
}));
export const deleteContent = createAction(DELETED_CONTENT, ({
  categoryId,
  contentId,
  contentType,
  id,
  newMasterId,
  onPageChange
}) => ({
  categoryId,
  contentId,
  contentType,
  id,
  newMasterId,
  onPageChange
}));
export const convertContent = createAction(CONVERTED_CONTENT, ({
  categoryId,
  contentType,
  id,
  newContentType
}) => ({
  categoryId,
  contentType,
  id,
  newContentType
}));
export const createTranslationVariation = createAction(CREATED_TRANSLATION_VARIATION, ({
  contentGroupId,
  contentType,
  id,
  language,
  masterLanguage,
  name,
  shouldCreateNewBlogVariation
}) => ({
  contentGroupId,
  contentType,
  id,
  language,
  masterLanguage,
  name,
  shouldCreateNewBlogVariation
}));
export const attachToLanguageMaster = createAction(ATTACHED_TO_LANGUAGE_MASTER, ({
  contentType,
  id,
  language,
  translatedFromId
}) => ({
  contentType,
  id,
  language,
  translatedFromId
}));
export const removeFromLanguageGroup = createAction(REMOVE_FROM_LANGUAGE_GROUP, ({
  contentType,
  id
}) => ({
  contentType,
  id
}));
export const changeAudienceAccess = createAction(CHANGED_CONTENT_AUDIENCE_ACCESS, ({
  audienceAccessType,
  contentType,
  id,
  lists,
  numContactsFromLists,
  password
}) => ({
  audienceAccessType,
  contentType,
  id,
  lists,
  numContactsFromLists,
  password
}));